import React from "react";
import SignupService from "./SignupService";
import { NavLink } from "react-router-dom";

const Signup = () => {
  const {
    input,
    handleSubmit,
    handleChange,
    showPassword,
    togglePassword,
    validationErrors,
    successPopUp,
    setSuccessPopUp,
  } = SignupService();
  return (
    <>
      <div className="cus-wrapper">
        <div className="cus-container-2">
          <div className="cus-new-flex">
            <div className="title">Registration</div>
            <div className="cus-click-back-page">
              <div class="cus-change-section ">
                <NavLink to="/">Back</NavLink>
              </div>
              <div class="back-icon-img">
                <img
                  src="assets/pwa-static/pwa/images/icons/angle-right.png"
                  class="back-icon"
                  alt="back icon"
                />
              </div>
            </div>
          </div>
          <div className="content">
            <form>
              <div className="user-details">
                <div className="input-box">
                  <input
                    type="text"
                    placeholder="Enter the name"
                    name="Name"
                    value={input?.Name}
                    onChange={handleChange}
                  />
                  {validationErrors.Name && (
                    <span className="text-danger-inputfield">
                      {validationErrors.Name}
                    </span>
                  )}
                </div>
                <div className="input-box">
                  <input
                    type="text"
                    placeholder="Enter the mobile number"
                    name="MobileNo" 
                    
                    value={input?.MobileNo}
                    onChange={handleChange}
                  />
                  {validationErrors.MobileNo && (
                    <span className="text-danger-inputfield">
                      {validationErrors.MobileNo} 
                      
                    </span>
                  )}
                </div>

                <div className="input-box">
                  <input
                    type="text"
                    placeholder="Enter the emailId"
                    name="EmailID"
                    value={input?.EmailID}
                    onChange={handleChange}
                  />
                  {validationErrors.EmailID && (
                    <span className="text-danger-inputfield">
                      {validationErrors.EmailID}
                    </span>
                  )}
                </div>
                <div className="input-box cus-address-area">
                  <input
                    type="text"
                    placeholder="Enter the address"
                    name="Address"
                    value={input?.Address}
                    onChange={handleChange}
                  />
                  {validationErrors.Address && (
                    <span className="text-danger-inputfield">
                      {validationErrors.Address}
                    </span>
                  )}
                </div>

                <div className="input-box">
                  <input
                    type="text"
                    placeholder="Enter the pincode"
                    name="Pincode"
                    value={input?.Pincode}
                    onChange={handleChange}
                  />
                  {validationErrors.Pincode && (
                    <span className="text-danger-inputfield">
                      {validationErrors.Pincode}
                    </span>
                  )}
                </div>

                <div className="input-box" style={{ position: "relative" }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter the Password"
                    name="Password"
                    value={input?.Password}
                    onChange={handleChange}
                  />
                  <span
                    onClick={togglePassword}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#333",
                    }}
                  >
                    {showPassword ? "🙈" : "👁️"}
                  </span>
                  {validationErrors.Password && (
                    <span className="text-danger-inputfield">
                      {validationErrors.Password}
                    </span>
                  )}
                </div>

                <div className="input-box">
                  <input
                    type="text"
                    placeholder="Enter the referral code"
                    name="ReferralNo"
                    value={input?.ReferralNo}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="cus-navlink-button">
                <NavLink to="/login">
                  <button type="button">Login</button>
                </NavLink>
                <button type="button" onClick={handleSubmit}>
                  Register
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {successPopUp && (
        <div
          className="content"
          style={{
            position: "fixed",
            top: "0px",
            left: "0px",
            width: "240vh",
            height: "100vh",
            backgroundColor: "rgb(34 48 51 / 37%)",
          }}
        >
          <div className="wrapper-1">
            <div className="wrapper-2">
              <div className="cus-tick">
                <img src="assets/pwa-static/pwa/images/icons/tick.png" alt="" />
                <span className="close" onClick={() => setSuccessPopUp(false)}>
                  x
                </span>
              </div>
              <h1>Success!</h1>
              <p>Your Account has been successfully created!</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Signup;
